import { render } from "./SleepView.vue?vue&type=template&id=2bde76de"
import script from "./SleepView.vue?vue&type=script&lang=js"
export * from "./SleepView.vue?vue&type=script&lang=js"

import "./SleepView.vue?vue&type=style&index=0&id=2bde76de&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__